module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiCnIt.c1b9902.eot";